import {
  IFeedbackConfig,
  IUser,
  TPlacement,
} from '@action/auth-button';

export interface IAuthButtonConfig {
  appid: string;
  productVersionIds?: (string | number)[];
  emid?: string;
  loginblock: string;
  user?: IUser;
  theme?: ITheme;
  supportlink?: string;
  reglink?: string;
  lang?: 'ru' | 'kz' | 'uz' | 'ua';
  mode?: 'dev' | 'rc' | 'prod';
  env?: 'develop' | 'production';
  text?: {
    emptyUserName?: string;
  };
  placement?: TPlacement;
  feedback?: IFeedbackConfig;
  onUserChange(user: IUser): void;
}

export interface ITheme {
  name: Themes;
  adaptive?: boolean;
}

export type Themes = 'light' | 'dark' | 'native' | 'ss';

interface IAppInit {
  (config: IAuthButtonConfig): void;
}

export const AUTH_BUTTON_READY_EVENT = 'auth-button:ready';

export class ActionAuthButton {
  private userHandler: (user: IUser) => void;

  private user: IUser | undefined;

  private onInit: IAppInit;

  private handlers: { [index: string]: Function } = {};

  private productVersionIds: (string | number)[];

  private ready = false;

  public constructor(onInit: IAppInit) {
    this.onInit = onInit;
    this.setHandler = this.setHandler.bind(this);
  }

  public init(config: IAuthButtonConfig) {
    this.onInit(config);
    this.setUser(config.user);
    if (config.productVersionIds) {
      this.setProductVersionIds(config.productVersionIds);
    }
  }

  public onUserChange(handler: (user: IUser) => void) {
    this.userHandler = handler;
  }

  public auth() {
    if (this.handlers.auth) {
      this.handlers.auth();
    }
  }

  public toggleDropdown() {
    if (this.handlers.toggleDropdown) {
      this.handlers.toggleDropdown();
    }
  }

  public setHandler(name: string, handler: Function) {
    this.handlers[name] = handler;
  }

  public setUser(user?: IUser) {
    this.user = user;
  }

  public setProductVersionIds(productVersionIds: (string | number)[]) {
    this.productVersionIds = productVersionIds;
  }

  public getUser() {
    return this.user;
  }

  public getProductVersionIds() {
    return this.productVersionIds;
  }

  public isReady(): boolean {
    return this.ready;
  }

  public markReady(): void {
    if (this.ready) return;
    this.ready = true;
    window.dispatchEvent(new CustomEvent(AUTH_BUTTON_READY_EVENT, { detail: { user: this.user } }));
  }

  // eslint-disable-next-line class-methods-use-this
  public subscribe() {
    // eslint-disable-next-line no-console
    console.info('Deprecated! Method subscribe');
  }

  // eslint-disable-next-line class-methods-use-this
  public unsubscribe() {
    // eslint-disable-next-line no-console
    console.info('Deprecated! Method  unsubscribe');
  }
}
